<div class="nip">
  <div class="nip-header">
    <div>
      <h3 class="nip-title">Upcoming Invoice Preview</h3>
      <p class="nip-subtitle">
        {{ formatDate(data.periodStart) }} – {{ formatDate(data.periodEnd) }}
      </p>
    </div>
    <button type="button" class="nip-close" aria-label="Close" (click)="close()">
      <i class="bx bx-x"></i>
    </button>
  </div>

  <div class="nip-note">
    <i class="bx bx-info-circle"></i>
    This is an estimate based on your current plan and add-ons — nothing has been charged yet.
    Add-ons are billed for the days you use them.
  </div>

  <div class="nip-items">
    @for (item of data.lineItems; track $index) {
      <div class="nip-item-row">
        <span class="nip-item-type" [class.nip-item-type--addon]="item.type === 'ADDON'">{{
          item.type
        }}</span>
        <div class="nip-item-info">
          <div class="nip-item-desc">{{ item.description }}</div>
          @if (item.quantity > 1 && !hasQuantityInLabel(item.description)) {
            <div class="nip-item-qty">Qty {{ item.quantity }}</div>
          }
        </div>
        <span class="nip-item-amount"
          >{{ getCurrencySymbol(data.currency) }}{{ (item.amountCents / 100).toFixed(2) }}</span
        >
      </div>
    }
  </div>

  <div class="nip-total-row">
    <span>Estimated Total</span>
    <span class="nip-total-amount"
      >{{ getCurrencySymbol(data.currency) }}{{ (data.amountDueCents / 100).toFixed(2) }}</span
    >
  </div>

  <div class="nip-actions">
    <button type="button" class="sub-btn sub-btn--dark" (click)="close()">Close</button>
  </div>
</div>
